import OrderType from '../utils/OrderType';
import { ORDER_TYPE_TRACKING_EVENT } from '../utils/constants';

import { getFulfillmentMethod } from './homeSelectors';
import { getFulfillmentType } from './orderStatusSelectors';

export const getTrackingHomeOrderType = (state) => {
  const fulfillmentMethod = getFulfillmentMethod(state);
  return { [ORDER_TYPE_TRACKING_EVENT]: OrderType.fromFulfillmentMethod(fulfillmentMethod) };
};

export const getOrderStatusTrackingOrderType = (state) => {
  const fulfillmentType = getFulfillmentType(state);
  return { [ORDER_TYPE_TRACKING_EVENT]: OrderType.fromFulfillmentType(fulfillmentType) };
};
